import axios from "axios";
import { PickupPoint } from "../models";

export const getPickupPoints = () => {
    return axios.get<PickupPoint[]>("Orders/PickupPoints");
}